var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.34,4.3H4.65A2.68,2.68,0,0,0,2,7V17A2.68,2.68,0,0,0,4.65,19.7h8.12V17.62H4.65A.62.62,0,0,1,4,17V7.52l6.6,4a2.62,2.62,0,0,0,2.65,0L20,7.66v3h2V7A2.68,2.68,0,0,0,19.34,4.3Zm-7,5.47a.59.59,0,0,1-.6,0L6.15,6.38H18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21,14.29H18.67V12a1,1,0,1,0-2.08,0v2.29H14.3a1,1,0,0,0,0,2.08h2.29v2.29a1,1,0,0,0,2.08,0V16.37H21a1,1,0,0,0,0-2.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMessage);
export default __webpack_public_path__ + "static/media/new-message.66b620cc0ff49054c84aeb31635a671d.svg";
export { ForwardRef as ReactComponent };